export type TextReplacement = {
    type: string;
    oldText: string;
    newText: string;
};

export type TextReplacementBlock = {
    oldText: string;
    newText: string;
};

export enum TextReplacementIndexKey {
    PERSON_NAME = 'PERSON_NAME',
    TICKET_NAME = 'TICKET_NAME',
}

export type TextReplacementIndex = Partial<
    Record<TextReplacementIndexKey, TextReplacementBlock[]>
>;

export const transformTrToTrIndex = (
    textReplacements: TextReplacement[]
): TextReplacementIndex => {
    const index: TextReplacementIndex = {};

    textReplacements.forEach(({ type, oldText, newText }) => {
        if (index[type]) {
            index[type].push({ oldText, newText });
        } else {
            index[type] = [{ oldText, newText }];
        }
    });

    return index;
};

import { MultiLangString } from '@/models/general';

export type ConfigurationIdNameMap = {
    id: string;
    name: string;
};

export type ProductPersonNameConfiguration = {
    persons: ConfigurationIdNameMap[];
    products: ConfigurationIdNameMap[];
};

export type ProductTextReplacement = {
    productId: string;
    personTypeId: string;
    newProductName: MultiLangString;
    newPersonTypeName: MultiLangString;
};

export type ProductTextReplacementDetail = {
    productId: string;
    personTypeId: string;
    newProductName: MultiLangString;
    newPersonTypeName: MultiLangString;
    productName?: string;
    personTypeName?: string;
};

export const convertDetailToProductTextReplacement = (
    detail: ProductTextReplacementDetail
): ProductTextReplacement => {
    const copy = { ...detail };

    delete copy.personTypeName;
    delete copy.productName;

    return copy;
};
